import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

export default function requireAuthentication(Komponent) {
  class AuthComponent extends Component {
    componentWillMount() {
      this.checkAuth();
    }

    componentWillReceiveProps() {
      this.checkAuth();
    }

    checkAuth() {
      const redirectAfterLogin = this.props.location.pathname;
      if (!this.props.isUserAuthenticated) {
        browserHistory.push(`/login?next=${redirectAfterLogin}`);
      } else if (!this.props.isCustomerAuthenticated && redirectAfterLogin !== '/customer-info') {
        browserHistory.push('/customer-info');
      }
    }
    componentDidCatch(error, info) {
      console.log(error, info);
    }
    render() {
      return (<div>
        {this.props.isUserAuthenticated === true
          ? <Komponent {...this.props} />
          : null
        }
      </div>);
    }
  }
  return connect(state => ({
    isCustomerAuthenticated: state.customer.customerDetails.data,
    isUserAuthenticated: state.user.isLoggedIn
  }))(AuthComponent);
}
